<div class="button-shell" matTooltip="Add to Collection" matTooltipShowDelay="500" (click)="openAddProjectToCollectionDialog()" [ngClass]="{'button': isButton}">
    <span>
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="18"
            height="18" viewBox="0 0 20 20">
            <path class="bookmark" d="M9 3V18H12V3H9M12 5L16 18L19 17L15 4L12 5M5 5V18H8V5H5M3 19V21H21V19H3Z" />
        </svg>
    </span>
</div>
